import React, { useContext } from 'react';
import { Modal } from '@ontruck/orc';
import ReactTooltip from 'react-tooltip';

import AssignmentMapContext from 'modules/assignment-map/map/context';

import Header from './header';
import AssignmentMap from './map';

const AssignmentMapModal = ({ eventEmitter }) => {
  const { itineraryId, closeModal } = useContext(AssignmentMapContext);

  if (!itineraryId) {
    return null;
  }

  return (
    <>
      <Modal
        withPadding={false}
        show={true}
        size="XL"
        onClose={closeModal}
        headerComponent={<Header />}
      >
        <AssignmentMap eventEmitter={eventEmitter} />
      </Modal>
      <ReactTooltip
        id="assignmentStopsMarker"
        effect="solid"
        type="light"
        place="right"
        multiline
      />
    </>
  );
};

export default AssignmentMapModal;
